import { createSlice } from '@reduxjs/toolkit';

interface InitialStateProps {
  request: {
    isLoading: boolean;
    error: string | null;
  };
  list: {
    isLoading: boolean;
    hits: any[] | null;
    total: number | null;
    error: string | null;
  };
  one: {
    isLoading: boolean;
    data: Record<string, any> | null;
    error: string | null;
  };
  warehouse: {
    isLoading: boolean;
    hits: any[] | null;
    total: number | null;
    error: string | null;
  };
}

const initialState: InitialStateProps = {
  request: {
    isLoading: false,
    error: null,
  },
  list: {
    isLoading: false,
    hits: null,
    total: null,
    error: null,
  },
  one: {
    isLoading: false,
    data: null,
    error: null,
  },
  warehouse: {
    isLoading: false,
    hits: null,
    total: null,
    error: null,
  },
};

export const { actions: districtActions, reducer: districtReducer } = createSlice({
  name: 'district',
  initialState,
  reducers: {
    //Request
    setDistrictRequestStart: (state) => {
      state.request = {
        isLoading: true,
        error: null,
      };
    },
    setDistrictRequestSuccess: (state) => {
      state.request = {
        isLoading: false,
        error: null,
      };
    },
    setDistrictRequestFailure: (state, { payload }) => {
      state.request = {
        isLoading: false,
        error: payload.message,
      };
    },
    setDistrictRequestDefault: (state) => {
      state.request = {
        isLoading: false,
        error: null,
      };
    },
    //List
    setDistrictListRequest: (state) => {
      state.list = {
        isLoading: true,
        hits: null,
        total: null,
        error: null,
      };
    },
    setDistrictListSuccess: (state, { payload }) => {
      state.list = {
        isLoading: false,
        hits: payload.hits,
        total: payload.total,
        error: null,
      };
    },
    setDistrictListFailure: (state, { payload }) => {
      state.list = {
        isLoading: false,
        hits: null,
        total: null,
        error: payload.message,
      };
    },
    setDistrictListDefault: (state) => {
      state.list = {
        isLoading: false,
        hits: null,
        total: null,
        error: null,
      };
    },
    //One
    setDistrictOneRequest: (state) => {
      state.one = {
        isLoading: true,
        data: null,
        error: null,
      };
    },
    setDistrictOneSuccess: (state, { payload }) => {
      state.one = {
        isLoading: false,
        data: payload,
        error: null,
      };
    },
    setDistrictOneFailure: (state, { payload }) => {
      state.one = {
        isLoading: false,
        data: null,
        error: payload.message,
      };
    },
    setDistrictOneDefault: (state) => {
      state.one = {
        isLoading: false,
        data: null,
        error: null,
      };
    },
    //Warehouse
    setDistrictWarehouseRequest: (state) => {
      state.warehouse = {
        isLoading: true,
        hits: null,
        total: null,
        error: null,
      };
    },
    setDistrictWarehouseSuccess: (state, { payload }) => {
      state.warehouse = {
        isLoading: false,
        hits: payload.hits,
        total: payload.total,
        error: null,
      };
    },
    setDistrictWarehouseFailure: (state, { payload }) => {
      state.warehouse = {
        isLoading: false,
        hits: null,
        total: null,
        error: payload.message,
      };
    },
    setDistrictWarehouseDefault: (state) => {
      state.warehouse = {
        isLoading: false,
        hits: null,
        total: null,
        error: null,
      };
    },
  },
});
